import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  PromoCode,
  SetBookedProductsPromoCodeDiscount,
  SetUnredeemedPromoCode
} from '@products/models/smart-promotions';

export const BookingSmartPromotionActions = createActionGroup({
  source: 'Booking Smart Promotion ',
  events: {
    'Set promo code discount': (redeemPromoCode: PromoCode) => ({ redeemPromoCode }),
    'Set promo code discount on confirmation step init': emptyProps(),
    'Remove and release promo code discount': emptyProps(),
    'Set unredeemed promo code': props<SetUnredeemedPromoCode>(),
    'Remove unredeemed promo code': (removePromoCode: PromoCode) => ({ removePromoCode }),
    'Set booked products promo code discount': props<SetBookedProductsPromoCodeDiscount>(),
    'Remove booked products promo code discount on changed product bookings': emptyProps(),
    'Remove booked products promo code discount': emptyProps()
  }
});
